import React, { useEffect, useState } from 'react';
import { ToastContainer, cssTransition } from 'react-toastify';
import { useDarkMode } from '../contexts/DarkModeContext';
import './toast.css';

/* Toast (CC8): one container, one look (toast.css). Bottom-right on desktop,
 * top-centre on phones, matching the shell's phone breakpoint. */
const PHONE_MQ = '(max-width: 899px)';

const lnrToast = cssTransition({
  enter: 'lnr-toast-enter',
  exit: 'lnr-toast-exit',
  appendPosition: true,
  collapse: true,
  collapseDuration: 220,
});

function useIsPhone(): boolean {
  const [phone, setPhone] = useState<boolean>(() => {
    try {
      return (
        typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(PHONE_MQ).matches
      );
    } catch {
      return false;
    }
  });
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(PHONE_MQ);
    const onChange = () => setPhone(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  return phone;
}

const ToastContainerWrapper: React.FC = () => {
  const { enabled: darkModeEnabled } = useDarkMode();
  const isPhone = useIsPhone();

  return (
    <ToastContainer
      position={isPhone ? 'top-center' : 'bottom-right'}
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={darkModeEnabled ? 'dark' : 'light'}
      transition={lnrToast}
    />
  );
};

export default ToastContainerWrapper;
